import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const initialState = {
  farms: [],
  userData: null,
  status: 'idle',
  error: null,
};

// --- FETCH FARMS ---
export const fetchUserFarms = createAsyncThunk(
  'userFarms/fetchUserFarms',
  async ({ id }, { rejectWithValue }) => {
    try {
      const role = getRole();

      // FIELD OFFICER
      if (role === 'FIELD_OFFICER') {
        const { data } = await axiosInstance.get(`/field-officer/farms/${id}`);
        return { mode: 'FIELD_OFFICER', data: data.data };
      }

      // PARTNER
      if (role === 'PARTNER' || role === 'TEAM_MEMBER') {
        const { data } = await axiosInstance.get(`/field-officer/farms/${id}`);
        return { mode: 'PARTNER', data: data.data };
      }

      // SUPPORT
      const { data } = await axiosInstance.get(`super-admin/user-farm/${id}`);
      return { mode: 'SUPPORT', data: data };

    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Failed to fetch farms');
    }
  }
);

// DELETE FARM (Field Officer)
export const deleteFarm = createAsyncThunk(
  'userFarms/deleteFarm',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.delete(`/field-officer/farms/${id}`);
      return { id, msg: data.message };
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Failed to delete farm');
    }
  }
);

const userFarmsSlice = createSlice({
  name: 'userFarms',
  initialState,
  reducers: {
    resetFarmsState(state) {
      state.farms = [];
      state.userData = null;
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchUserFarms.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUserFarms.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const { mode, data } = action.payload;
        
        if (mode === 'SUPPORT') {
          state.farms = data.farmData || [];
          state.userData = data.userData || null;
        } else {
          state.farms = data || [];
          state.userData = null;
        }
      })
      .addCase(fetchUserFarms.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteFarm.fulfilled, (state, action) => {
        state.farms = state.farms.filter((farm) => farm.farm_id !== action.payload.id);
      });
  },
});

export const { resetFarmsState } = userFarmsSlice.actions;
export default userFarmsSlice.reducer;